// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "ribbon-module--base-text-alt--global--05e8a";
export var baseTextGlobal = "ribbon-module--base-text--global--a4b3a";
export var blockSpacing100 = "ribbon-module--block-spacing-100--27b6b";
export var blockSpacing50 = "ribbon-module--block-spacing-50--3fafc";
export var blockVPadding100 = "ribbon-module--block-v-padding-100--946dd";
export var blockVPadding50 = "ribbon-module--block-v-padding-50--0f48c";
export var captionTextGlobal = "ribbon-module--caption-text--global--140e8";
export var cmsRenderedContentGlobal = "ribbon-module--cms-rendered-content--global--5d988";
export var defaultHSpacingGlobal = "ribbon-module--default-h-spacing--global--958c7";
export var fadeInAnimation = "ribbon-module--fadeInAnimation--f2b05";
export var fadeInOnLoadGlobal = "ribbon-module--fade-in-on-load--global--f0634";
export var fullHeightGlobal = "ribbon-module--full-height--global--8511d";
export var fullHeightOmittingNavGlobal = "ribbon-module--full-height-omitting-nav--global--b226f";
export var headingTextGlobal = "ribbon-module--heading-text--global--df0cb";
export var image = "ribbon-module--image--a137a";
export var ingressTextGlobal = "ribbon-module--ingress-text--global--31766";
export var linkColorChangeTransitionGlobal = "ribbon-module--link-color-change-transition--global--09d0c";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "ribbon-module--page-heading-text--global--27193";
export var paragraphTextGlobal = "ribbon-module--paragraph-text--global--3fb4e";
export var ribbon = "ribbon-module--ribbon--0d2a6";
export var subheadingTextGlobal = "ribbon-module--subheading-text--global--5391f";
export var text = "ribbon-module--text--035be";